/**
 * Do not edit directly
 * Generated on Fri, 15 May 2026 07:16:25 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
